import { render } from "./CreateAPIKeyModal.vue?vue&type=template&id=3ec24f54"
import script from "./CreateAPIKeyModal.vue?vue&type=script&lang=ts"
export * from "./CreateAPIKeyModal.vue?vue&type=script&lang=ts"
script.render = render

export default script